/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type IntegrationForm_integration$ref: FragmentReference;
declare export opaque type IntegrationForm_integration$fragmentType: IntegrationForm_integration$ref;
export type IntegrationForm_integration = {|
  +id: string,
  +metadata: any,
  +rawMetadata: ?any,
  +isEnabled: boolean,
  +source: {|
    +id: string,
    +name: string,
    +metadataSchema: ?any,
  |},
  +$refType: IntegrationForm_integration$ref,
|};
export type IntegrationForm_integration$data = IntegrationForm_integration;
export type IntegrationForm_integration$key = {
  +$data?: IntegrationForm_integration$data,
  +$fragmentRefs: IntegrationForm_integration$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "IntegrationForm_integration",
  "type": "Integration",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "rawMetadata",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isEnabled",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "source",
      "storageKey": null,
      "args": null,
      "concreteType": "IntegrationSource",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "metadataSchema",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '45259b12f5c08b30657f5dcca8d714d0';
module.exports = node;
